import { render, staticRenderFns } from "./ClinicReceiptIncomeReport.vue?vue&type=template&id=5bc8a1c8&scoped=true"
import script from "./ClinicReceiptIncomeReport.vue?vue&type=script&lang=js"
export * from "./ClinicReceiptIncomeReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bc8a1c8",
  null
  
)

export default component.exports